import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

import { useSelectedFacility } from "@/app/FacilityContext";
import { useMyFacilityActions } from "@/hooks/use-my-facility-actions";
import type { FacilityDetail } from "@/libs/facilityApi";

export function PrivateCourtSetupCard({ facility }: { facility: FacilityDetail }) {
  const { actions, isReady } = useMyFacilityActions(facility.facility_id);
  const { setFacility } = useSelectedFacility();
  const navigate = useNavigate();
  if (!isReady || !actions.includes("facility:court")) return null;
  return (
    <Card>
      <CardContent>
        <Stack spacing={1.5} sx={{ alignItems: "flex-start" }}>
          <Typography component="h2" variant="h6">Prepare your courts</Typography>
          <Typography color="text.secondary" variant="body2">
            Set up court names, capacity, and tags for {facility.name} before your
            business is approved. This is private preparation and does not
            make your facility available to players.
          </Typography>
          <Button variant="outlined" onClick={() => {
            setFacility(facility.facility_id, facility.name, facility.facility_type ?? null);
            navigate("/courts");
          }}>
            Set up courts
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}
